import { SWRConfig } from "swr";
import { useConfig } from "hooks/useConfig";

export const AppCacheConfig = ({ children }) => {
    const { openNotification } = useConfig();

    const swrConfig = {
        revalidateOnFocus: false,
        throwOnError: false,
        onError: (error) => {
            let errorMessage = error.message;
            if (error.response && Array.isArray(error.response.data.detail)) {
                errorMessage = error.response.data.detail[0].msg;
            }
            openNotification({
                status: "error",
                message: "Error",
                description: errorMessage
            });
        },
        onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
            if (error.status === 404 || retryCount >= 3) {
                return;
            }
            setTimeout(() => revalidate({ retryCount }), 5000);
        }
    };

    return <SWRConfig value={swrConfig}>{children}</SWRConfig>;
};
